import { IReservationStatus } from 'modules/accommodations/features/reservations/models';
import API from 'services/api';

export const getCalculationStatusTypes = (): Promise<IReservationStatus[]> =>
  API.get('api/accommodation/calculation-statustypes').then(response => response?.data);
